import { useRecoilValue } from 'recoil'
import sandboxAtom from '../Sandbox/sandbox.atom'
import { PropsWithChildren, useEffect, useMemo, useState } from 'react'
import css from './versionProvider.module.css'
import useHttpLoader from '../../hooks/useHttpLoader'
import Dropdown from '../../shared/Inputs/Dropdown'
import { ReactComponent as PlusIcon } from '../../asserts/icons/plus.svg'
import CreateVersionModal from './CreateVersionModal'
import { IPack } from '../../services/packs/packs.types'
import packsService from '../../services/packs/packs.service'
import FlyingRocketLayout from '../../shared/Layouts/FlyingRocketLayout'
import NbmgButton from '../../shared/NbmgButton'
import useLoadPack from './hooks/useLoadPack'

const VersionProvider = (props: PropsWithChildren) => {
  const { wait: waitGetPacks, loading: packsLoading } = useHttpLoader()
  const sandboxState = useRecoilValue(sandboxAtom)

  const [createModalOpen, setCreateModalOpen] = useState(false)
  const [availableVersions, setAvailableVersions] = useState<IPack[]>([])
  const [selectedVersion, setSelectedVersion] = useState<IPack['id']>(null)
  const loadPackCtrl = useLoadPack()

  const versionOptions = useMemo(() => {
    return availableVersions
      .slice()
      .reverse()
      .map((v) => ({ title: v.name + ' (v. ' + v.version.toString() + ')', value: v.id }))
  }, [availableVersions])

  useEffect(() => {
    waitGetPacks(packsService.getPacks(), (packs) => {
      setAvailableVersions(packs)
    })
  }, [])

  const handleCreate = (pack: IPack) => {
    setAvailableVersions((prev) => [...prev, pack])
    setSelectedVersion(pack.id)
    setCreateModalOpen(false)
  }

  const handleNext = () => {
    const pack = availableVersions.find((p) => p.id === selectedVersion)
    loadPackCtrl.load(pack)
  }

  if (!sandboxState.version) {
    const renderDropdown = () => {
      return (
        <Dropdown
          options={versionOptions}
          selectedOption={selectedVersion}
          title={packsLoading ? 'Загрузка...' : 'Пак не выбран'}
          onSelect={setSelectedVersion as any}
          loading={packsLoading}
        />
      )
    }

    return (
      <FlyingRocketLayout>
        {createModalOpen && <CreateVersionModal onCreate={handleCreate} onClose={() => setCreateModalOpen(false)} />}
        <div className={css.container}>
          <div className="flex-form">
            <h2 className="form-header" style={{ textAlign: 'center' }}>
              Выберите пак
            </h2>
            <div className={css.content}>
              <div></div>
              {renderDropdown()}
              <PlusIcon
                className={css.plus}
                title="добавить версию"
                height={30}
                width={30}
                onClick={() => setCreateModalOpen(true)}
              />
            </div>
            <div className={css.footer}>
              <NbmgButton
                onClick={handleNext}
                loading={loadPackCtrl.loading}
                withHands={true}
                disabled={!selectedVersion}
              >
                Перейти к заданиям
              </NbmgButton>
            </div>
          </div>
        </div>
      </FlyingRocketLayout>
    )
  }

  return <>{props.children}</>
}

export default VersionProvider
